import { useContext, useEffect, useState, type FunctionComponent } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Navigate } from 'react-router-dom';
import { getCancelCreditEligible } from '../../services/growth';
import { pages } from '../../utils/pages';
import { getPage } from '../../utils/paginator';
import { SurveyPageContext } from '../context/SurveyPageContext';
import QuestionPage from '../question-page';
import Welcome from '../welcome';

const SURVEY_INITIAL_PAGE = 0;
export enum Subscription {
  Annual = 'ANNUAL',
  Seasonal = 'SEASONAL',
}

export type SubscriptionType = Subscription.Annual | Subscription.Seasonal;

const Container: FunctionComponent = () => {
  const { paginatedSurvey, surveyPage } = useContext(SurveyPageContext);
  const { cancelAddonsCreditOfferAccess: cancelAddonsCreditOfferAccessFF } = useFlags();
  const [showCreditModal, setShowCreditModal] = useState(false);
  const closeCreditModal = () => setShowCreditModal(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [surveyPage]);

  // Display Cancel Add-ons Credit modal on page number 2
  useEffect(() => {
    const getIsEligible = async () => {
      const { eligible } = await getCancelCreditEligible();
      if (eligible) setShowCreditModal(true);
    };
    if (surveyPage === 2 && cancelAddonsCreditOfferAccessFF) {
      getIsEligible();
    }
  }, [surveyPage, cancelAddonsCreditOfferAccessFF]);

  if (surveyPage === SURVEY_INITIAL_PAGE) {
    return <Welcome />;
  }

  if (paginatedSurvey?.has(surveyPage)) {
    const currentPageQuestions = getPage({
      paginatedSurvey,
      page: surveyPage,
      defaultValue: [],
    });
    return (
      <QuestionPage
        questions={currentPageQuestions}
        showCreditModal={showCreditModal}
        closeCreditModal={closeCreditModal}
      />
    );
  }

  return <Navigate to={pages.CANCEL_SUBSCRIPTION_FINAL.path} replace />;
};

export default Container;
